module.exports = __webpack_public_path__ + "img/game-console.c2e5403a.png";